import { action } from '@ember/object';
import { trackedObject } from '@ember/reactive/collections';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MarketParityParityManagerIssueuploadRoute extends Route {
  queryParams = {
    subscriptionId: {},
    issueId: {},
    issueType: {},
  };

  @service access;
  @service ajax;
  @service alerting;
  @service errorTracking;
  @service('hotel-and-market') hotelAndMarketService;
  @service transition;

  beforeModel(transition) {
    if (!this.access.can('market.paritymanager.files.edit')) {
      this.transition.redirectToTab(transition, 'market.parity.parity-manager');
    }
  }

  model(params) {
    const model = trackedObject({
      additionalScreenshot: null,
      additionalScreenshotFilename: null,
      extranetScreenshot: null,
      extranetScreenshotFilename: null,
      isLoading: true,
      screenshotsUrl: null,
    });

    if (
      params.subscriptionId &&
      params.issueId &&
      this.hotelAndMarketService.market?.id
    ) {
      // Request the correct HTML code for the escalation mail preview on init
      this.ajax
        .request(
          `${this.ajax.host}/apigateway/v1/app/paritymanager/get_attachments?market_id=${this.hotelAndMarketService.market?.id}&subscription_id=${params.subscriptionId}&issue_id=${params.issueId}&issue_type=${params.issueType}`,
          {
            method: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
          },
        )
        .then((response) => {
          if (response.additional_screenshot) {
            model.additionalScreenshot = response.additional_screenshot;
            model.additionalScreenshotFilename =
              response.additional_screenshot_filename;
          }
          if (response.extranet_screenshot) {
            model.extranetScreenshot = response.extranet_screenshot;
            model.extranetScreenshotFilename =
              response.extranet_screenshot_filename;
          }
          if (response.screenshots_url) {
            model.screenshotsUrl = response.screenshots_url;
          }

          model.isLoading = false;
        })
        .catch((error) => {
          model.isLoading = false;
          this.errorTracking.captureException(error);
          this.alerting.showErrorAlert();
        });
    } else {
      model.isLoading = false;
      this.alerting.showErrorAlert();
    }

    return model;
  }

  @action
  refreshRoute() {
    this.refresh();
  }
}
